import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';

export const Wrapper = styled(Flex)<{
  alignItems?: string;
  isFullWidthMobile: boolean;
}>`
  position: fixed;
  inset: 0;
  align-items: ${({ alignItems }) => (alignItems ? alignItems : 'flex-start')};
  justify-content: center;
  overflow-x: hidden;
  display: flex;

  ${({ isFullWidthMobile, theme }) => css`
    background-color: ${theme.colors.white};
    z-index: ${theme.zIndex.overlay};
    max-width: 100vw;
    ${theme.media.sm.up} {
      background-color: rgba(0, 0, 0, 0.6);
      align-items: center;
      justify-content: center;
    }
    ${!isFullWidthMobile &&
    css`
      background-color: rgba(0, 0, 0, 0.6);
    `}
  `}
`;
